import { Injectable } from "@angular/core";
import { UnsubscribeBaseServiceModel } from "../client/UnsubscribeBaseService.model";
import { AppData } from "../AppData";
import { HttpClient } from "@angular/common/http";
import { UrlBuilder } from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import { take } from "rxjs/operators";
import { WorkGroupModel } from "../../models/work_group/work-group.model";
import { Observable } from "rxjs";
import { CompoApp } from "../CompoApp";

@Injectable()
export class WorkGroupRequestService extends UnsubscribeBaseServiceModel {

  private data: AppData;

  constructor(private http: HttpClient,
              private app: CompoApp) {
    super();
    this.data = app.data;
  }

  getById(id: string) : Observable<WorkGroupModel> {
    const url = new UrlBuilder(Constants.URLS.workGroups.getById)
      .param('id', id)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.get<WorkGroupModel>(url).pipe(take(1));
  }

  create(model: WorkGroupModel): Observable<WorkGroupModel> {
    const url = new UrlBuilder(Constants.URLS.workGroups.save)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.post<WorkGroupModel>(url, model).pipe(take(1));
  }

  update(model: WorkGroupModel) : Observable<WorkGroupModel> {
    const url = new UrlBuilder(Constants.URLS.workGroups.updateB)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<WorkGroupModel>(url, model).pipe(take(1));
  }

  delete(workGroupId: string) : Observable<any> {
    const url = new UrlBuilder(Constants.URLS.workGroups.baseUrl + workGroupId).build();
    return this.http.delete(url).pipe(take(1));
  }

  workGroupNameExists(
    workGroupId: string,
    workGroupName: string,
    orgId: string,
    communityId: string
  ) : Observable<boolean> {
    const url = new UrlBuilder(Constants.URLS.workGroups.workGroupNameExists)
      .param('workGroupId', workGroupId)
      .param('workGroupName', workGroupName)
      .param('organizationId', orgId)
      .param('communityId', communityId)
      .build();
    return this.http.get<boolean>(url).pipe(take(1));
  }

}
